<template>
  <div>
    <modal-vue>
      <div slot="header" class="row">
        <h3>{{quiz.title}}</h3>
      </div>

      <div slot="body" style="margin:0px;">
        <div class="progress">
          <div
            v-bind:style="{ width: progressBar }"
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>

        <div class="exam-question" style="display: block;">
          <!-- <span class="status">Questão respondida</span> -->

          <span class="exam-question-title">
            <span class="question-title-number">{{questions[questionIndex].order+1}} -</span>

            <p style="font-size: 14px;">
              <span
                style="color:rgb(52, 58, 64); font-family:open sans,helvetica neue,helvetica,arial,sans-serif; font-size:14px"
              >{{questions[questionIndex].text}}</span>
            </p>
          </span>
          <div class="exam-anwser-options" :key="answerListKey" v-if="questions[questionIndex].type != 2">
            <li
            
              v-for="answer in questions[questionIndex].answers"
              :key="answer.id"
              v-bind:class="[{ selected: checkAnswer(answer)==true }, { correct: answer.isCorrect }]"
            >
              <p style="font-size: 14px;">
                <span
                  style="color:rgb(52, 58, 64); font-family:open sans,helvetica neue,helvetica,arial,sans-serif; font-size:14px"
                >{{answer.text}}</span>
              </p>
            </li>
          </div>

          <div class="exam-anwser-options" :key="answerListKey" v-if="questions[questionIndex].type == 2" >
                 <textarea v-model="questions[questionIndex].answers[0].text" style="width:100%; margin-top: 10px" rows="5" class="input-large" :disabled="true" maxlength='3000'></textarea>
          </div>


        </div>
      </div>

      <div slot="footer">
        <button style="float: left;" class="btn btn-danger" v-on:click="close()">Cancelar</button>
        <lms-button
          :disabled="!(0 < questionIndex)"
          @click="previousQuestion()"
          :loading="savingQuiz"
        >Anterior</lms-button>
        <lms-button
          :disabled="!(questions.length - 1 > questionIndex)"
          @click="nextQuestion()"
          :loading="savingQuiz"
        >Próxima</lms-button>

        <!-- <button class="btn btn-default" @click="saveVideos()">Salvar</button> -->
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
.correct{
  background: #28a74596 !important;
}
.custom-grid-modal-2 {
  grid-template-columns: 0.3fr 0.3fr 1.5fr 0.3fr !important;
}

.custom-grid-modal {
  grid-template-columns: 0.3fr 1fr 0.3fr 0.3fr 0.3fr !important;
}

.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>


<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: ["moduleId"],
  data() {
    return {
      answerCount: 0,
      answerListKey: 0,
      selectedAnswerId: -1,
      questionIndex: 0,
      savingQuiz: false,
      course: this.$store.getters.course,
      answers: []
    };
  },
  computed: {
    ...mapState(["quiz", "questions"]),
    progressBar() {
      return (this.questionIndex * 100) / (this.questions.length - 1) + "%";
    }
  },
  methods: {
    checkAnswer(answer){
      let found = false;
      this.answers.find(function (element){
        console.log(element);
        if(element.answerId == answer.id && element.questionId == answer.questionId){
          found = true;
        }
      });
      
      return found;
    },
    nextQuestion() {
      console.log(this.questions);
      if (this.questions.length - 1 > this.questionIndex) {
        this.questionIndex = this.questionIndex + 1;
      }
    },
    previousQuestion() {
      if (this.questionIndex > 0) {
        this.questionIndex -= 1;
      }
    },
    getQuiz() {
      this.$store.dispatch("loadQuiz", this.moduleId);
      this.getAnswers();
    },
    close() {
      this.$emit("close");
    },
    getAnswers() {
      console.log(this.quiz.id);
      const path = this.$global.endpoint + "/quiz/execution/answer/getall";
      axios
        .post(path, {
          quizId: this.quiz.id
        })
        .then(res => {
          this.answers = res.data;
          console.log(this.answers);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getQuiz();
    this.$store.watch(
      (state, getters) => getters.quiz,
      (newValue, oldValue) => {
        console.log(`Updating from ${oldValue} to ${newValue}`);

        this.getAnswers();
      }
    );
  }
};
</script>
